import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { request } from 'utilities/graph';
import { queryAddress } from 'graphql/mutations';
import DataForm from 'forms/DataForm';
import schema from './updateAddressSchema';
import { formatAddress } from 'utilities/format';
import { toastr } from 'react-redux-toastr';

export default function UpdateAddressButton({
  onUpdate,
  ordersSelected,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    if (ordersSelected.current[0]) {
      setData({ address: ordersSelected.current[0].elder.address });
    }
  }, [ordersSelected.current]);

  const handleSubmit = async () => {
    setIsLoading(true);
    // check address
    let queryResult;
    try {
      const params = {
        input: {
          queryAddressMethod: 'tgos',
          address: formatAddress(data.address, { includeZipCode: false, ignoreNote: true }),
        },
      };
      const { data: { queryAddress: { data: result } } } = await request(queryAddress, params);
      if (!result.lat || !result.lng) {
        toastr.error('無法定位輸入的地址');
      }
      queryResult = result;
    } catch (e) {
      toastr.error('無法定位輸入的地址');
      console.error(e);
    } finally {
      setIsLoading(false);
    }
    if (queryResult.lat && queryResult.lng) {
      onUpdate && onUpdate({
        ...data.address,
        lat: queryResult.lat,
        lng: queryResult.lng,
      });
      handleClose();
    }
  };

  const handleClose = () => {
    setOpen(false);
    setData(undefined);
  };

  return (
    <Fragment>
      <Button
        style={ { marginLeft: 10 } }
        variant="contained"
        color="primary"
        onClick={async () => {
          setOpen(true);
        }}
      >
        修改送餐地址
      </Button>
      <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        onClose={(e, reason)=>{
          if (reason === 'escapeKeyDown' || reason === 'backdropClick') return;
          handleClose();
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent style={{ marginBottom: 30 }}>
          <DataForm
            schema={schema}
            uiSchema={{}}
            createFunc={() => {}}
            updateFunc={() => {}}
            onChange={(data) => {
              setData(data);
            }}
            dirty={true}
            formData={data}
            hideSubmitButton
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default" disabled={isLoading}>
            取消
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained"
            disabled={isLoading || !data || !data.address || !data.address.district || !data.address.street}>
            確定
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

UpdateAddressButton.propTypes = {
  onUpdate: PropTypes.func,
  ordersSelected: PropTypes.object,
};
